export const SetLocalDelegacao = (delegacao) => {
    localStorage.setItem('delegacao', delegacao)
    document.cookie = `delegacao=${delegacao}`;
}

export const GetLocalDelegacao = () => localStorage.getItem('delegacao')

export const DeleteLocalDelegacao = () => localStorage.removeItem('delegacao')

export const GetLocalDelegacaoCookie = () => getCookie('delegacao')

function getCookie(nome) {
    const cookies = document.cookie.split("; "); // Divide os cookies em pares key=value
    for (let i = 0; i < cookies.length; i++) {
        const [key, value] = cookies[i].split("="); // Divide cada par
        if (key === nome) {
            return decodeURIComponent(value); // Decodifica o valor
        }
    }
    return null; // Retorna null se o cookie não for encontrado
}